import React, { useState } from "react";
import imageCompression from "browser-image-compression";
import img from "../assets/Spinner-3.gif";

function NewBgc() {
  const [isSameAddressChecked, setIsSameAddressChecked] = useState(false);
  const [selectExperience, setSelectExperience] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [fresher, setFresher] = useState(false);
  const [step, setStep] = useState(1);

  /* first form field */

  const [name, setName] = useState("");
  const [fname, setFname] = useState("");
  const [mname, setMname] = useState("");
  const [gender, setGender] = useState("");
  const [date, setDate] = useState("");
  const [email, setEmail] = useState("");
  const [number, setNumber] = useState("");
  const [enumber, setEnumber] = useState("");
  const [companyname, setCompanyName] = useState("Passionworkx Infotech");
  const [location, setLocation] = useState("");
  const [language, setLanguage] = useState("");

  const [address1, setAddress1] = useState("");
  const [address2, setAddress2] = useState("");
  const [pincode, setPincode] = useState("");
  const [state, setState] = useState("");

  const [address11, setAddress11] = useState("");
  const [address22, setAddress22] = useState("");
  const [pincode1, setPincode1] = useState("");
  const [state1, setState1] = useState("");

  /* forth form field */
  const [aadhar, setAadhar] = useState("");
  const [aadhar_front_side, setAadhar_Front_Side] = useState("");
  const [aadhar_back_side, setAadhar_Back_Side] = useState("");
  const [passport_size_photo, setPassport_Size_Photo] = useState("");
  const [candidate, setCandidateId] = useState("");

  const [formValues, setFormValues] = useState([
    {
      previous_company_name: "",
      previous_designation: "",

      hr_name: "",
      Hr_number: "",
      Hr_email_id: "",

      Employee_id: "",
      previous_salary: "",

      reason_of_leaving: "",
      previous_manager: "",

      previous_manager_number: "",
      previous_manager_email_id: "",

      from_previous_company: "",
      to_previous_company: "",

      location: "",
      work_reponsibility: "",

      payslip: "",
      pay_slip2: "",
      pay_slip3: "",

      offer_letter: "",
      resignation: "",
      experience_letter: "",
    },
  ]);

  const handleChange = (index, event) => {
    const { name, value } = event.target;
    if (name === "previous_salary" && value.includes(".")) {
      setError("Values cannot be entered in the points field");
    } else {
      setError("");
    }
    const updatedFormValues = [...formValues];
    updatedFormValues[index][name] = value;
    setFormValues(updatedFormValues);
  };

  const handleFileChange1 = async (event, index, fieldName) => {
    const file = event.target.files[0];
    if (file) {
      try {
        const fileType = file.type;

        if (
          fileType === "application/pdf" ||
          fileType === "image/jpeg" ||
          fileType === "image/png" ||
          fileType === "image/jpg"
        ) {
          let fileToSet = file;
          if (fileType !== "application/pdf") {
            const options = {
              maxSizeMB: 0.2,
              maxWidthOrHeight: 1920,
              useWebWorker: true,
            };
            fileToSet = await imageCompression(file, options);
          }
          const updatedFormValues = [...formValues];
          updatedFormValues[index][fieldName] = fileToSet;
          setFormValues(updatedFormValues);
        } else {
          console.error(
            "Unsupported file format. Please upload a PDF, JPG, JPEG, or PNG file."
          );
        }
      } catch (error) {
        console.error("Error processing file:", error);
      }
    }
  };

  const [error, setError] = useState("");

  const handleFileChange = async (event, setStateFunction) => {
    const file = event.target.files[0];
    if (file) {
      try {
        const fileType = file.type;

        if (
          fileType === "application/pdf" ||
          fileType === "image/jpeg" ||
          fileType === "image/png" ||
          fileType === "image/jpg"
        ) {
          if (fileType === "application/pdf") {
            setStateFunction(file);
          } else {
            const options = {
              maxSizeMB: 0.2,
              maxWidthOrHeight: 1920,
              useWebWorker: true,
            };

            const compressedFile = await imageCompression(file, options);
            setStateFunction(compressedFile);
          }
        } else {
          console.error(
            "Unsupported file format. Please upload a PDF, JPG, JPEG, or PNG file."
          );
        }
      } catch (error) {
        console.error("Error processing file:", error);
      }
    }
  };

  const billingFunction = () => {
    setIsSameAddressChecked((prevValue) => !prevValue);
    if (isSameAddressChecked) {
      setAddress11("");
      setAddress22("");
      setPincode1("");
      setState1("");
    } else {
      setAddress11(address1);
      setAddress22(address2);
      setPincode1(pincode);
      setState1(state);
    }
  };

  // Step headings
  const steps = ["Personal Details", "Employement"];

  const [errors, setErrors] = useState({});

  // Move to previous step
  const prevStep = () => {
    if (step > 1) setStep(step - 1);
  };

  /*first page next......... */
  const validateStep1 = () => {
    const newErrors = {};

    // Required fields validation
    if (!name) newErrors.name = "Name of the Applicant is required";
    if (!fname) newErrors.fname = "Father's Name is required";
    if (!gender) newErrors.gender = "Gender is required";
    if (!date) newErrors.date = "Date of Birth is required";
    if (!email) {
      newErrors.email = "Email is required";
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      newErrors.email = "Invalid email format";
    }
    if (!number) {
      newErrors.number = "Contact Number is required";
    } else if (isNaN(number)) {
      newErrors.number = "Contact Number must be a number";
    }
    if (!enumber) {
      newErrors.enumber = "Emergency Contact is required";
    } else if (isNaN(enumber)) {
      newErrors.enumber = "Emergency Contact must be a number";
    }
    if (!location) newErrors.location = "Company Location is required";

    // Permanent Address validation
    if (!address1) newErrors.address1 = "Address Line 1 is required";
    if (!pincode) {
      newErrors.pincode = "Pin Code is required";
    } else if (isNaN(pincode)) {
      newErrors.pincode = "Pin Code must be a number";
    }
    if (!state) newErrors.state = "State is required";

    // Current Address validation
    if (!address11) newErrors.address11 = "Address Line 1 is required";
    if (!pincode1) {
      newErrors.pincode1 = "Pin Code is required";
    } else if (isNaN(pincode1)) {
      newErrors.pincode1 = "Pin Code must be a number";
    }
    if (!state1) newErrors.state1 = "State is required";
    if (!aadhar) {
      newErrors.aadhar = "Aadhar Number is required";
    } else if (!/^\d{12}$/.test(aadhar)) {
      newErrors.aadhar = "Aadhar must be exactly 12 digits";
    }
    if (!aadhar_front_side)
      newErrors.aadhar_front_side = "Aadhar Front Side is required";
    if (!aadhar_back_side)
      newErrors.aadhar_back_side = "Aadhar Back Side is required";
    if (!passport_size_photo)
      newErrors.passport_size_photo = "passport Size Photo is required";

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const nextStep1 = () => {
    if (validateStep1()) {
      setStep((prevStep) => prevStep + 1);
    } else {
      alert("Please fill out all required fields");
    }
  };
  let addFormFields = () => {
    setFormValues([
      ...formValues,
      {
        previous_company_name: "",
        previous_designation: "",

        hr_name: "",
        Hr_number: "",
        Hr_email_id: "",

        Employee_id: "",
        previous_salary: "",

        reason_of_leaving: "",
        previous_manager: "",

        previous_manager_number: "",
        previous_manager_email_id: "",

        from_previous_company: "",
        to_previous_company: "",

        location: "",
        work_reponsibility: "",

        payslip: "",
        pay_slip2: "",
        pay_slip3: "",

        offer_letter: "",
        resignation: "",
        experience_letter: "",
      },
    ]);
  };

  const hideEmployment = (e) => {
    const selected = e.target.value;

    if (selected === "Experience") {
      setSelectExperience(true);
      setFresher(false);
    } else if (selected === "Fresher") {
      setSelectExperience(false);
      const confirmed = window.confirm(
        "Are You Sure You Want To Submit This Form As Fresher?"
      );
      if (confirmed) {
        setSelectExperience(false);
        setIsLoading(true);
        setFresher("fresher");
        document
          .querySelectorAll("input, select, textarea, button")
          .forEach((element) => {
            element.disabled = true;
          });
        setTimeout(() => {
          BgcFormSubmitFresher({ preventDefault: () => {} });
        }, 1000);
      } else {
        e.target.value = "";
        setSelectExperience(false);
        setFresher(false);
        setFresher(true);
        document
          .querySelectorAll("input, select, textarea, button")
          .forEach((element) => {
            element.disabled = false;
          });
      }
    } else {
      setSelectExperience(false);
      setFresher(false);
      setFresher(true);
      document
        .querySelectorAll("input, select, textarea, button")
        .forEach((element) => {
          element.disabled = false;
        });
    }
  };

  const removeFormFields = (index) => {
    const newFormValues = [...formValues];
    newFormValues.splice(index, 1);
    setFormValues(newFormValues);
  };

  const BgcFormSubmit = async (e) => {
    setIsLoading(true);
    if (e?.preventDefault) e.preventDefault();

    if (!fresher && selectExperience) {
      // Validate required fields
      const requiredFields = [
        "previous_company_name",
        "previous_designation",
        "hr_name",
        "Hr_number",
        "Hr_email_id",
        "Employee_id",
        "previous_salary",
        "reason_of_leaving",
        "previous_manager",
        "previous_manager_number",
        "previous_manager_email_id",
        "from_previous_company",
        "to_previous_company",
        "location",
        "work_reponsibility",
      ];

      const isAnyFieldEmpty = formValues.some((form) => {
        return requiredFields.some((field) => {
          const value = form[field];
          return value === null || value === undefined || value === "";
        });
      });

      if (isAnyFieldEmpty) {
        alert("Please fill all required fields in all employment entries");
        setIsLoading(false);
        return;
      }

      const numericFields = [
        "Hr_number",
        "previous_manager_number",
        "previous_salary",
      ];
      const hasInvalidNumber = formValues.some((form) => {
        return numericFields.some((field) => {
          const value = form[field];
          return isNaN(value) || value.toString().includes(".");
        });
      });

      if (hasInvalidNumber) {
        alert(
          "Please enter valid whole numbers for HR number, manager number, and salary"
        );
        setIsLoading(false);
        return;
      }

      const emailFields = ["Hr_email_id", "previous_manager_email_id"];
      const hasInvalidEmail = formValues.some((form) => {
        return emailFields.some((field) => {
          const value = form[field];
          const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
          return !emailRegex.test(value);
        });
      });

      if (hasInvalidEmail) {
        alert("Please enter valid email addresses");
        setIsLoading(false);
        return;
      }

      const dateFields = ["from_previous_company", "to_previous_company"];
      const hasInvalidDate = formValues.some((form) => {
        return dateFields.some((field) => {
          const value = form[field];
          return !value || isNaN(new Date(value).getTime());
        });
      });

      if (hasInvalidDate) {
        alert("Please enter valid dates in YYYY-MM-DD format");
        setIsLoading(false);
        return;
      }
    }

    const formData = new FormData();

    formData.append("full_name", name);
    formData.append("fathers_name", fname);
    formData.append("mothers_name", mname);
    formData.append("gender", gender);
    formData.append("dob", date);
    formData.append("email", email);
    formData.append("contact_number", number);
    formData.append("emergency_number", enumber);
    formData.append("name_of_the_client", companyname);
    formData.append("client_location", location);
    formData.append("language_known", language);

    // Permanent Address
    formData.append("permanent_village_city", address1);
    formData.append("permanent_village_city2", address2);
    formData.append("permanent_pincode", pincode);
    formData.append("permanent_state", state);

    // Current Address
    formData.append("current_village_city", address11);
    formData.append("current_village_city2", address22);
    formData.append("current_pincode", pincode1);
    formData.append("current_state", state1);

    // Documents
    formData.append("adhar_number", aadhar);
    formData.append("adhar_frontside", aadhar_front_side);
    formData.append("adhar_backside", aadhar_back_side);
    formData.append("photo", passport_size_photo);

    if (selectExperience) {
      const employmentdata = formValues.map((form) => ({
        previous_company_name: form.previous_company_name,
        previous_designation: form.previous_designation,
        hr_name: form.hr_name,
        Hr_number: parseInt(form.Hr_number, 10),
        Hr_email_id: form.Hr_email_id,
        Employee_id: form.Employee_id,
        previous_salary: parseInt(form.previous_salary, 10),
        reason_of_leaving: form.reason_of_leaving,
        previous_manager: form.previous_manager,
        previous_manager_number: parseInt(form.previous_manager_number, 10),
        previous_manager_email_id: form.previous_manager_email_id,
        from_previous_company: form.from_previous_company,
        to_previous_company: form.to_previous_company,
        location: form.location,
        work_reponsibility: form.work_reponsibility,
      }));
      formData.append("employmentdata", JSON.stringify(employmentdata));
    } else {
      formData.append("employmentdata", JSON.stringify([]));
    }

    console.log("Submitting form data...");

    try {
      const response = await fetch(
        "https://humhai.in/background-verification/newform/",
        {
          method: "POST",
          body: formData,
        }
      );

      const data = await response.json();

      console.log(data);
      setCandidateId(data.id);

      if (data.status === 200) {
        alert("Your form has been successfully submitted.");
        setIsLoading(false);
        window.location.reload();
      } else {
        alert("Something went wrong. Please try again.");
        setIsLoading(false);
      }
    } catch (error) {
      console.error("Error:", error);
      alert("There was an error submitting the form.");
      setIsLoading(false);
    } finally {
      setIsLoading(false);
      document
        .querySelectorAll("input, select, textarea, button")
        .forEach((element) => {
          element.disabled = false;
        });
    }
  };

  const BgcFormSubmitFresher = async (e) => {
    setIsLoading(true);
    if (e?.preventDefault) e.preventDefault();

    const formData = new FormData();

    formData.append("full_name", name);
    formData.append("fathers_name", fname);
    formData.append("mothers_name", mname);
    formData.append("gender", gender);
    formData.append("dob", date);
    formData.append("email", email);
    formData.append("contact_number", number);
    formData.append("emergency_number", enumber);
    formData.append("name_of_the_client", companyname);
    formData.append("client_location", location);
    formData.append("language_known", language);

    // Permanent Address
    formData.append("permanent_village_city", address1);
    formData.append("permanent_village_city2", address2);
    formData.append("permanent_pincode", pincode);
    formData.append("permanent_state", state);

    // Current Address
    formData.append("current_village_city", address11);
    formData.append("current_village_city2", address22);
    formData.append("current_pincode", pincode1);
    formData.append("current_state", state1);

    // Documents
    formData.append("adhar_number", aadhar);
    formData.append("adhar_frontside", aadhar_front_side);
    formData.append("adhar_backside", aadhar_back_side);
    formData.append("photo", passport_size_photo);

    if (selectExperience) {
      const employmentdata = formValues.map((form) => ({
        fresher: form.fresher,
      }));
      formData.append("employmentdata", JSON.stringify(employmentdata));
    } else {
      const fresherEmploymentData = [
        {
          fresher: "fresher",
        },
      ];
      formData.append("employmentdata", JSON.stringify(fresherEmploymentData));
    }

    console.log("1Submitting form data...");
    for (let [key, value] of formData.entries()) {
      console.log(`${key}:`, value);
    }

    try {
      const response = await fetch(
        "https://humhai.in/background-verification/newform/",
        {
          method: "POST",
          body: formData,
        }
      );

      const data = await response.json();

      console.log(data, "data");
      setCandidateId(data.id);

      if (data.status === 200) {
        alert("Your form has been successfully submitted.");
        setIsLoading(false);
        window.location.reload();
      } else {
        alert("Something went wrong. Please try again.");
        setIsLoading(false);
      }
    } catch (error) {
      console.error("Error:", error);
      alert("There was an error submitting the form.");
      setIsLoading(false);
    } finally {
      setIsLoading(false);
      document
        .querySelectorAll("input, select, textarea, button")
        .forEach((element) => {
          element.disabled = false;
        });
    }
  };

  return (
    <div className="form-container">
      <div className="form-header">
        {steps.map((heading, index) => (
          <div
            key={index}
            className={`step-title ${
              step === index + 1 ? "active" : "blurred"
            }`}
          >
            {heading}
          </div>
        ))}
      </div>

      {/* Form Content */}
      <div className="form-content">
        {step === 1 && (
          <div>
            <div className="bg-light p-2 rounded-lg border border-opacity-50 mx-auto">
              <h4 className="text-center font-bold text-xl mb-2">
                CANDIDATE{" "}
                <span className="text-orange-600">PERSONAL DETAILS</span>
              </h4>
              <hr />
              <div className="row g-2">
                <div className="col-md-3 col-12">
                  <label
                    htmlFor="name_of_applicant"
                    className="form-label small"
                  >
                    Name of the Applicant
                  </label>
                  <input
                    type="text"
                    className={`form-control form-control-sm mb-2 ${
                      errors.name ? "is-invalid" : ""
                    }`}
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                    name="name_of_applicant"
                    required
                  />
                  {errors.name && (
                    <div className="invalid-feedback">{errors.name}</div>
                  )}
                </div>
                <div className="col-md-3 col-12">
                  <label htmlFor="Input2" className="form-label small">
                    Fathers/Husband/Wife Name
                  </label>
                  <input
                    className={`form-control form-control-sm mb-2 ${
                      errors.fname ? "is-invalid" : ""
                    }`}
                    list="projects"
                    value={fname}
                    onChange={(e) => setFname(e.target.value)}
                    name="fathers_name"
                    maxLength="100"
                    required
                  />
                  {errors.fname && (
                    <div className="invalid-feedback">{errors.fname}</div>
                  )}
                </div>
                <div className="col-md-3 col-12">
                  <label htmlFor="Input4" className="form-label small">
                    Applicant Gender
                  </label>{" "}
                  <select
                    className={`form-control form-control-sm mb-2 ${
                      errors.gender ? "is-invalid" : ""
                    }`}
                    value={gender}
                    onChange={(e) => setGender(e.target.value)}
                    name="gender"
                  >
                    <option value="">choose</option>
                    <option value="Male">Male</option>
                    <option value="Female">Female</option>
                    <option value="other">other</option>
                  </select>
                  {errors.gender && (
                    <div className="invalid-feedback">{errors.gender}</div>
                  )}
                </div>
                <div className="col-md-3 input-icons">
                  <label htmlFor="Input5" className="form-label small">
                    Date Of Birth
                  </label>

                  <div className="date-container">
                    <input
                      value={date}
                      onChange={(e) => setDate(e.target.value)}
                      type="date"
                      className={`form-control form-control-sm mb-2 ${
                        errors.date ? "is-invalid" : ""
                      }`}
                      name="dob"
                      required
                    />
                    {errors.date && (
                      <div className="invalid-feedback">{errors.date}</div>
                    )}
                  </div>
                </div>
              </div>

              <div className="row g-2">
                <div className="col-md-3 col-12">
                  <label htmlFor="Input6" className="form-label small">
                    Email Id
                  </label>{" "}
                  <input
                    type="email"
                    className={`form-control form-control-sm mb-2 ${
                      errors.email ? "is-invalid" : ""
                    }`}
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    name="email"
                    required
                  />
                  {errors.email && (
                    <div className="invalid-feedback">{errors.email}</div>
                  )}
                </div>
                <div className="col-md-3 input-icons">
                  <label htmlFor="Input5" className="form-label small">
                    Contact Number
                  </label>

                  <div className="date-container">
                    <input
                      type="number"
                      className={`form-control form-control-sm mb-2 ${
                        errors.number ? "is-invalid" : ""
                      }`}
                      value={number}
                      onChange={(e) => setNumber(e.target.value)}
                      name="contact_number"
                      required
                    />
                    {errors.number && (
                      <div className="invalid-feedback">{errors.number}</div>
                    )}
                  </div>
                </div>
                <div className="col-md-3 col-12">
                  <label htmlFor="Input6" className="form-label small">
                    Emergency Contact
                  </label>

                  <input
                    type="number"
                    className={`form-control form-control-sm mb-2 ${
                      errors.enumber ? "is-invalid" : ""
                    }`}
                    value={enumber}
                    onChange={(e) => setEnumber(e.target.value)}
                    name="emergency_contact"
                    required
                  />
                  {errors.enumber && (
                    <div className="invalid-feedback">{errors.enumber}</div>
                  )}
                </div>

                <div className="col-md-3 col-12">
                  <label htmlFor="Input7" className="form-label small">
                    Company Name
                  </label>

                  <input
                    type="text"
                    className="form-control form-control-sm mb-2"
                    value={companyname}
                    onChange={(e) => setCompanyName(e.target.value)}
                    name="name_of_client"
                    maxLength="100"
                    disabled
                  />
                </div>
              </div>

              <div className="row g-2">
                <div className="col-md-3 col-12">
                  <label htmlFor="Input7" className="form-label small">
                    Company Location
                  </label>
                  <input
                    type="text"
                    className={`form-control form-control-sm mb-2 ${
                      errors.location ? "is-invalid" : ""
                    }`}
                    value={location}
                    onChange={(e) => setLocation(e.target.value)}
                    name="client_location"
                    maxLength="30"
                    required
                  />
                  {errors.location && (
                    <div className="invalid-feedback">{errors.location}</div>
                  )}
                </div>
                <div className="col-md-3 col-12">
                  <label htmlFor="Input7" className="form-label small">
                    Languages Known (optional)
                  </label>
                  <input
                    type="text"
                    className="form-control form-control-sm mb-2"
                    value={language}
                    onChange={(e) => setLanguage(e.target.value)}
                    name="languages"
                    maxLength="30"
                  />
                </div>
              </div>

              <div className="row g-2">
                <h5 style={{fontWeight:'bold'}}>Permanent Address</h5>
                <div className="col-md-3 col-12">
                  <label htmlFor="Input7" className="form-label small">
                    Address Line 1
                  </label>
                  <input
                    type="text"
                    className={`form-control form-control-sm mb-2 ${
                      errors.address1 ? "is-invalid" : ""
                    }`}
                    value={address1}
                    onChange={(e) => setAddress1(e.target.value)}
                    name="village_city"
                    maxLength="25"
                    required
                  />
                  {errors.address1 && (
                    <div className="invalid-feedback">{errors.address1}</div>
                  )}
                </div>
                <div className="col-md-3 col-12">
                  <label htmlFor="Input7" className="form-label small">
                    Address Line 2 (Optional)
                  </label>
                  <input
                    type="text"
                    className="form-control form-control-sm mb-2"
                    value={address2}
                    onChange={(e) => setAddress2(e.target.value)}
                    name="village_city2"
                    maxLength="25"
                  />
                </div>
                <div className="col-md-3 col-12">
                  <label htmlFor="Input7" className="form-label small">
                    Pin Code
                  </label>
                  <input
                    type="number"
                    className={`form-control form-control-sm mb-2 ${
                      errors.pincode ? "is-invalid" : ""
                    }`}
                    value={pincode}
                    onChange={(e) => setPincode(e.target.value)}
                    name="pine_code"
                    required
                  />
                  {errors.pincode && (
                    <div className="invalid-feedback">{errors.pincode}</div>
                  )}
                </div>
                <div className="col-md-3 col-12">
                  <label htmlFor="Input7" className="form-label small">
                    State
                  </label>
                  <input
                    type="text"
                    className={`form-control form-control-sm mb-2 ${
                      errors.state ? "is-invalid" : ""
                    }`}
                    value={state}
                    onChange={(e) => setState(e.target.value)}
                    name="state"
                    maxLength="20"
                    required
                  />
                  {errors.state && (
                    <div className="invalid-feedback">{errors.state}</div>
                  )}
                </div>
              </div>

              <div className="row mb-2 align-items-center">
                <div className="col-auto">
                  <input
                    type="checkbox"
                    id="same"
                    className="form-check-input"
                    onChange={() => billingFunction()}
                  />
                </div>
                <div className="col-auto">
                  <label htmlFor="same" className="form-check-label small">
                    Same as above?
                  </label>
                </div>
              </div>

              <div className="row g-2">
                <h5 style={{fontWeight:'bold'}}>Current Address</h5>
                <div className="col-md-3 col-12">
                  <label htmlFor="Input7" className="form-label small">
                    Address Line 1
                  </label>
                  <input
                    type="text"
                    className={`form-control form-control-sm mb-2 ${
                      errors.address11 ? "is-invalid" : ""
                    }`}
                    value={address11}
                    onChange={(e) => setAddress11(e.target.value)}
                    name="c_village_city"
                    maxLength="25"
                    required
                  />
                  {errors.address11 && (
                    <div className="invalid-feedback">{errors.address11}</div>
                  )}
                </div>
                <div className="col-md-3 col-12">
                  <label htmlFor="Input7" className="form-label small">
                    Address Line 2 (Optional)
                  </label>
                  <input
                    type="text"
                    className="form-control form-control-sm mb-2"
                    value={address22}
                    onChange={(e) => setAddress22(e.target.value)}
                    name="c_village_city2"
                    maxLength="25"
                  />
                </div>
                <div className="col-md-3 col-12">
                  <label htmlFor="Input7" className="form-label small">
                    Pin Code
                  </label>
                  <input
                    type="number"
                    className={`form-control form-control-sm mb-2 ${
                      errors.pincode1 ? "is-invalid" : ""
                    }`}
                    value={pincode1}
                    onChange={(e) => setPincode1(e.target.value)}
                    name="c_pine_code"
                    maxLength="100"
                    required
                  />
                  {errors.pincode1 && (
                    <div className="invalid-feedback">{errors.pincode1}</div>
                  )}
                </div>
                <div className="col-md-3 col-12">
                  <label htmlFor="Input7" className="form-label small">
                    State
                  </label>
                  <input
                    type="text"
                    className={`form-control form-control-sm mb-2 ${
                      errors.state1 ? "is-invalid" : ""
                    }`}
                    value={state1}
                    onChange={(e) => setState1(e.target.value)}
                    name="c_state"
                    maxLength="20"
                    required
                  />
                  {errors.state1 && (
                    <div className="invalid-feedback">{errors.state1}</div>
                  )}
                </div>
              </div>

              <hr />
              <h5
                className=" text-center"
                style={{ color: "rgb(255, 119, 0)" }}
              >
                * Upload a Fully Clear and Completed Document *
              </h5>
              <h4 style={{ color: "red", textAlign: "center" }}>
                * use .jpg and .png format *{" "}
              </h4>
              <div className="row g-2">
                <div className="col-md-3 col-12">
                  <label htmlFor="Input7" className="form-label small">
                    Aadhar Card Number
                  </label>
                  <input
                    type="text"
                    value={aadhar}
                    onChange={(e) => {
                      const value = e.target.value
                        .replace(/\D/g, "")
                        .slice(0, 12);
                      setAadhar(value);
                      if (errors.aadhar && value.length === 12) {
                        setErrors({ ...errors, aadhar: "" });
                      }
                    }}
                    name="aadhar_card"
                    className={`form-control form-control-sm mb-2 ${
                      errors.aadhar ? "is-invalid" : ""
                    }`}
                    inputMode="numeric"
                    pattern="\d{12}"
                    maxLength="12"
                    placeholder="Enter 12-digit Aadhar number"
                    required
                  />
                  {errors.aadhar && (
                    <div className="invalid-feedback">
                      {errors.aadhar === "Aadhar Number is required"
                        ? "Aadhar Number is required"
                        : "Aadhar must be exactly 12 digits (numbers only)"}
                    </div>
                  )}
                </div>
                <div className="col-md-3 col-12">
                  <label htmlFor="Input8" className="form-label small">
                    Aadhar Card FRONT SIDE
                  </label>
                  <input
                    type="file"
                    onChange={(e) => handleFileChange(e, setAadhar_Front_Side)}
                    accept=".png, .jpg"
                    name="aadhar_front"
                    className={`form-control form-control-sm mb-2 ${
                      errors.aadhar_front_side ? "is-invalid" : ""
                    }`}
                    required
                  />
                  {errors.aadhar_front_side && (
                    <div className="invalid-feedback">
                      {errors.aadhar_front_side}
                    </div>
                  )}
                </div>
                <div className="col-md-3 col-12">
                  <label htmlFor="Input9" className="form-label small">
                    Aadhar Card BACK SIDE
                  </label>
                  <input
                    type="file"
                    onChange={(e) => handleFileChange(e, setAadhar_Back_Side)}
                    name="aadhar_back"
                    accept=".png, .jpg"
                    className={`form-control form-control-sm mb-2 ${
                      errors.aadhar_back_side ? "is-invalid" : ""
                    }`}
                    required
                  />
                  {errors.aadhar_back_side && (
                    <div className="invalid-feedback">
                      {errors.aadhar_back_side}
                    </div>
                  )}
                </div>
                <div className="col-md-3 col-12">
                  <label htmlFor="Input9" className="form-label small">
                    Passport Size Photo
                  </label>
                  <input
                    type="file"
                    onChange={(e) =>
                      handleFileChange(e, setPassport_Size_Photo)
                    }
                    name="passport_photo"
                    accept=".png, .jpg"
                    className={`form-control form-control-sm mb-2 ${
                      errors.passport_size_photo ? "is-invalid" : ""
                    }`}
                    required
                  />
                  {errors.passport_size_photo && (
                    <div className="invalid-feedback">
                      {errors.passport_size_photo}
                    </div>
                  )}
                </div>
              </div>
            </div>
            <div style={{ overflow: "auto" }}>
              <div style={{ float: "right" }}>
                <button
                  type="button"
                  className="tablinks mb-2 ms-2"
                  onClick={nextStep1}
                >
                  Next
                </button>
              </div>
            </div>
          </div>
        )}

        {step === 2 && (
          <div>
            <div className="bg-light rounded-3 p-2 mx-auto mb-3 border border-opacity-25">
              <h4 className="text-center font-bold text-xl mb-2">
                💼 CANDIDATE
                <span style={{ color: "rgb(255, 119, 0)" }}>
                  {" "}
                  PREVIOUS EMPLOYEMENT
                </span>{" "}
                DETAILS
              </h4>
              <h4 style={{ color: "red", textAlign: "center" }}>
                * use .jpg and .png format *{" "}
              </h4>
              <hr />
              <div className="col-md-3 col-sm-6">
                <label>Employment Choose</label>
                <select
                  className="form-control mt-3"
                  name="choose_tenancy"
                  id="employment1"
                  onChange={hideEmployment}
                  required
                >
                  <option value="">Choose</option>
                  <option value="Fresher">Fresher</option>
                  <option value="Experience">Experience</option>
                </select>
                <div className="row ms-4 mb-4">
                  {isLoading ? (
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        zIndex: "1",
                        flexDirection: "column",
                      }}
                    >
                      {" "}
                      <img src={img} alt="" />
                      <div
                        style={{
                          color: "#DE3500",
                          marginTop: "10px",
                        }}
                      >
                        Please Wait ......
                      </div>
                    </div>
                  ) : (
                    ""
                  )}
                </div>
              </div>
              {/* {selectExperience ? ( */}
              {selectExperience && (
                <div>
                  {Array.isArray(formValues) &&
                    formValues.map((element, index) => (
                      <div
                        className="form-inline"
                        key={index}
                        disabled={index !== formValues.length - 1}
                      >
                        <div className="d-flex justify-content-between align-items-center mb-3">
                          <h5>Employment #{index + 1}</h5>
                          {formValues.length > 1 && (
                            <button
                              type="button"
                              className="btn btn-danger btn-sm"
                              onClick={() => {
                                if (
                                  window.confirm(
                                    "Are you sure you want to remove this employment entry?"
                                  )
                                ) {
                                  removeFormFields(index);
                                }
                              }}
                              disabled={isLoading}
                            >
                              Remove
                            </button>
                          )}
                        </div>
                        <div>
                          <div className="row g-2">
                            <div className="col-md-3 col-12">
                              <label htmlFor="organisation">Company Name</label>
                              <input
                                type="text"
                                value={element.previous_company_name || ""}
                                onChange={(e) => handleChange(index, e)}
                                name="previous_company_name"
                                className="form-control form-control-sm mb-2"
                                maxLength="100"
                                disabled={index !== formValues.length - 1}
                                required
                              />
                            </div>

                            <div className="col-md-3 col-12">
                              <label htmlFor="designation">Designation</label>

                              <input
                                type="text"
                                value={element.previous_designation || ""}
                                onChange={(e) => handleChange(index, e)}
                                name="previous_designation"
                                className="form-control form-control-sm mb-2"
                                maxLength="100"
                                disabled={index !== formValues.length - 1}
                                required
                              />
                            </div>

                            <div className="col-md-3 col-12">
                              <label htmlFor="Employee_id">Employee Id</label>

                              <input
                                type="text"
                                value={element.Employee_id || ""}
                                onChange={(e) => handleChange(index, e)}
                                name="Employee_id"
                                className="form-control form-control-sm mb-2"
                                maxLength="100"
                                disabled={index !== formValues.length - 1}
                                required
                              />
                            </div>
                            <div className="col-md-3 col-12">
                              <label htmlFor="hr_name">HR Name</label>
                              <input
                                type="text"
                                value={element.hr_name || ""}
                                onChange={(e) => handleChange(index, e)}
                                name="hr_name"
                                className="form-control form-control-sm mb-2"
                                maxLength="100"
                                disabled={index !== formValues.length - 1}
                                required
                              />
                            </div>
                          </div>

                          <div className="row g-2">
                            <div className="col-md-3 col-12">
                              <label htmlFor="Hr_number">
                                HR Contact Number
                              </label>
                              <input
                                type="number"
                                value={element.Hr_number || ""}
                                onChange={(e) => handleChange(index, e)}
                                name="Hr_number"
                                className="form-control form-control-sm mb-2"
                                disabled={index !== formValues.length - 1}
                                required
                              />
                            </div>

                            <div className="col-md-3 col-12">
                              <label htmlFor="Hr_email_id">HR Email Id</label>

                              <input
                                type="email"
                                value={element.Hr_email_id || ""}
                                onChange={(e) => handleChange(index, e)}
                                name="Hr_email_id"
                                className="form-control form-control-sm mb-2"
                                disabled={index !== formValues.length - 1}
                                required
                              />
                            </div>

                            <div className="col-md-3 col-12">
                              <label htmlFor="previous_salary">
                                Annual CTC *
                              </label>
                              <input
                                type="number"
                                value={element.previous_salary || ""}
                                onChange={(e) => handleChange(index, e)}
                                name="previous_salary"
                                className="form-control form-control-sm mb-2"
                                disabled={index !== formValues.length - 1}
                                required
                              />
                              {error && <p style={{ color: "red" }}>{error}</p>}
                            </div>

                            <div className="col-md-3 col-12">
                              <label htmlFor="reason_of_leaving">
                                Reason of leaving
                              </label>
                              <input
                                type="text"
                                value={element.reason_of_leaving || ""}
                                onChange={(e) => handleChange(index, e)}
                                name="reason_of_leaving"
                                className="form-control form-control-sm mb-2"
                                maxLength="255"
                                disabled={index !== formValues.length - 1}
                                required
                              />
                            </div>
                          </div>
                        </div>

                        <div className="row g-2">
                          <div className="col-md-3 col-12">
                            <label htmlFor="designation">
                              Work Responsibility
                            </label>
                            <input
                              type="text"
                              value={element.work_reponsibility || ""}
                              onChange={(e) => handleChange(index, e)}
                              name="work_reponsibility"
                              className="form-control form-control-sm mb-2"
                              maxLength="100"
                              disabled={index !== formValues.length - 1}
                              required
                            />
                          </div>
                          <div className="col-md-3 col-12">
                            <label htmlFor="previous_manager">
                              Supervisor/Manager Name
                            </label>
                            <input
                              type="text"
                              value={element.previous_manager || ""}
                              onChange={(e) => handleChange(index, e)}
                              name="previous_manager"
                              className="form-control form-control-sm mb-2"
                              maxLength="100"
                              disabled={index !== formValues.length - 1}
                              required
                            />
                          </div>

                          <div className="col-md-3 col-12">
                            <label htmlFor="previous_manager_number">
                              Supervisor/Manager Number *
                            </label>

                            <input
                              type="number"
                              value={element.previous_manager_number || ""}
                              onChange={(e) => handleChange(index, e)}
                              name="previous_manager_number"
                              className="form-control form-control-sm mb-2"
                              maxLength="255"
                              disabled={index !== formValues.length - 1}
                              required
                            />
                          </div>

                          <div className="col-md-3 col-12">
                            <label htmlFor="previous_manager_email_id">
                              Supervisor/Manager Email Id *
                            </label>
                            <input
                              type="email"
                              value={element.previous_manager_email_id || ""}
                              onChange={(e) => handleChange(index, e)}
                              name="previous_manager_email_id"
                              className="form-control form-control-sm mb-2"
                              maxLength="100"
                              disabled={index !== formValues.length - 1}
                              required
                            />
                          </div>
                        </div>

                        <div className="row g-2">
                          <div className="col-md-3 col-12">
                            <label htmlFor="from_previous_company">From</label>

                            <input
                              type="date"
                              value={element.from_previous_company || ""}
                              onChange={(e) => handleChange(index, e)}
                              name="from_previous_company"
                              className="form-control form-control-sm mb-2"
                              disabled={index !== formValues.length - 1}
                              required
                            />
                          </div>
                          <div className="col-md-3 col-12">
                            <label htmlFor="to_previous_company">To</label>

                            <input
                              type="date"
                              value={element.to_previous_company || ""}
                              onChange={(e) => handleChange(index, e)}
                              name="to_previous_company"
                              className="form-control form-control-sm mb-2"
                              disabled={index !== formValues.length - 1}
                              required
                            />
                          </div>
                          <div className="col-md-3 col-12">
                            <label htmlFor="organisation">Location</label>
                            <input
                              type="text"
                              value={element.location || ""}
                              onChange={(e) => handleChange(index, e)}
                              name="location"
                              className="form-control form-control-sm mb-2"
                              maxLength="100"
                              disabled={index !== formValues.length - 1}
                              required
                            />
                          </div>
                          <div className="col-md-3 col-12">
                            <label htmlFor="payslip">Pay Slip 1</label>
                            <input
                              type="file"
                              name="payslip"
                              onChange={(e) =>
                                handleFileChange1(e, index, "payslip")
                              }
                              className="form-control form-control-sm mb-2"
                              disabled={index !== formValues.length - 1}
                              accept=".png, .jpg"
                              required
                            />
                          </div>
                        </div>

                        <div className="row g-2">
                          <div className="col-md-3 col-12">
                            <label htmlFor="pay_slip2">Pay Slip 2</label>
                            <input
                              type="file"
                              name="pay_slip2"
                              accept=".png, .jpg"
                              onChange={(e) =>
                                handleFileChange1(e, index, "pay_slip2")
                              }
                              className="form-control form-control-sm mb-2"
                              disabled={index !== formValues.length - 1}
                              required
                            />
                          </div>

                          <div className="col-md-3 col-12">
                            <label htmlFor="pay_slip3">Pay Slip 3</label>
                            <input
                              type="file"
                              name="pay_slip3"
                              accept=".png, .jpg"
                              onChange={(e) =>
                                handleFileChange1(e, index, "pay_slip3")
                              }
                              className="form-control form-control-sm mb-2"
                              disabled={index !== formValues.length - 1}
                              required
                            />
                          </div>
                          <div className="col-md-3 col-12">
                            <label htmlFor="offer_latter">Offer Letter</label>
                            <input
                              type="file"
                              name="offer_letter"
                              accept=".png, .jpg"
                              onChange={(e) =>
                                handleFileChange1(e, index, "offer_letter")
                              }
                              className="form-control form-control-sm mb-2"
                              disabled={index !== formValues.length - 1}
                              required
                            />
                          </div>
                          <div className="col-md-3 col-12">
                            <label htmlFor="resignation_latter">
                              Resignation Letter
                            </label>
                            <input
                              type="file"
                              name="resignation"
                              accept=".png, .jpg"
                              onChange={(e) =>
                                handleFileChange1(e, index, "resignation")
                              }
                              className="form-control form-control-sm mb-2"
                              disabled={index !== formValues.length - 1}
                              required
                            />
                          </div>
                        </div>

                        <div className="row g-2">
                          <div className="col-md-3 col-12">
                            <label htmlFor="resignation_latter">
                              Experience Letter
                            </label>

                            <input
                              type="file"
                              name="experience_letter"
                              accept=".png, .jpg"
                              onChange={(e) =>
                                handleFileChange1(e, index, "experience_letter")
                              }
                              className="form-control form-control-sm mb-2"
                              disabled={index !== formValues.length - 1}
                              required
                            />
                          </div>
                        </div>

                        <div className="row ms-4 mb-4">
                          {isLoading ? (
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                zIndex: "1",
                                flexDirection: "column",
                              }}
                            >
                              {" "}
                              <img src={img} alt="" />
                              <div
                                style={{
                                  color: "#DE3500",
                                  marginTop: "10px",
                                }}
                              >
                                Please Wait ......
                              </div>
                            </div>
                          ) : (
                            ""
                          )}
                        </div>
                      </div>
                    ))}

                  <div className="button-section">
                    <button
                      type="button"
                      className="tablinks mb-2 ms-2"
                      style={{ backgroundColor: "#BBBBBB" }}
                      onClick={prevStep}
                      disabled={isLoading}
                    >
                      Previous
                    </button>
                    <div style={{ overflow: "auto" }}>
                      <div style={{ float: "right" }}>
                        <button
                          type="button"
                          className="tablinks mb-2 ms-2"
                          style={{
                            backgroundColor: "green",
                            color: "white",
                            padding: "8px 16px",
                            borderRadius: "4px",
                            border: "none",
                            cursor: "pointer",
                            transition: "background-color 0.3s",
                          }}
                          onMouseOver={(e) =>
                            (e.currentTarget.style.backgroundColor =
                              "darkgreen")
                          }
                          onMouseOut={(e) =>
                            (e.currentTarget.style.backgroundColor = "green")
                          }
                          onClick={addFormFields}
                          disabled={isLoading}
                        >
                          Add +
                        </button>
                        <button
                          type="submit"
                          className="tablinks mb-2 ms-2"
                          onClick={(e) => BgcFormSubmit(e)}
                          disabled={isLoading}
                        >
                          Submit
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
export default NewBgc;
